import $ from 'jquery'
import Swiper from 'swiper/js/swiper.js'

export default {
  init() {
    $('.interview a').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-with-zoom',
      gallery:{
        enabled:true
      },
      zoom: {
        enabled: true,
        duration: 300,
        easing: 'ease-in-out'
      }
    });

    const slide = new Swiper('.jwd-slide', {
      // init: false,
      pagination: {
        el: '.jwd-slide-pagination',
        clickable: true,
      },
      loop: true,
      autoHeight: true,
      autoplay: {
        delay: 4000,
      },
      speed: 400,
      effect: 'fade',
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 0,
    })
  },
  finalize() {
  },
}